import React from "react";
import { useSelector } from "react-redux";
import GoogleChart, { commonOptions } from "../../../../components/charts/googleChart/googleChart";
import NoData from "../../../../components/noData/noData";

const DiscountsPieChart = () => {
  const pieCharts = useSelector((state) => state.discounts.chartsData.pieCharts);

  if (!pieCharts) return null;

  let {
    data_table: { cols, rows },
    options
  } = pieCharts[0];

  return (
    <div className="pie-chart">
      {rows.length ? (
        <GoogleChart
          width={700}
          height={300}
          chartType="PieChart"
          columns={cols}
          rows={rows}
          options={{ ...commonOptions, ...options }}
          showCurrency={false}
          showAdditionTooltip={false}
          showXLSX={false}
        />
      ) : (
        <NoData />
      )}
    </div>
  );
};

export default DiscountsPieChart;
